import { faClock } from '@fortawesome/free-solid-svg-icons'
import React, { useCallback } from 'react'
import { NotificationProps } from '../../FactoryNotification/FactoryNotification'
import GenericNotification from '../GenericNotification'


interface NewOvertimeProposalNotificationProps extends NotificationProps {
	item: {
		id: string, 
		notifMsg: string, 
		timestamp: number, 
		viewed: boolean,
		notifData: {
			approved: string, 
			receivedFromType: string, 
            userName: string,
            transactionId: string
		},
	}
}


const NewOvertimeProposalNotification = ({ item, clickable, onSetNotificationAsView }: NewOvertimeProposalNotificationProps) => {
	const { id, notifMsg, timestamp, viewed, notifData: { approved } } = item

	const touchNotification =  useCallback(
	  () => {
        if(!viewed)
            onSetNotificationAsView(id)
	  },
	  [],
	)
	
	return(
		<GenericNotification 
			touchNotification={touchNotification} 
			

			id={id}
			timestamp={timestamp}
			viewed={clickable ? viewed : true}
			description={"User wants to add overtime"}
			title={ "Username wants to add overtime to the meet" }

			icon={ faClock }
            color={ "#5d5d5d" }
		/>
	)
}

export default React.memo(NewOvertimeProposalNotification)